/// <reference path="./compat.d.ts" />
//
import lightbox from "lightbox2";
import "bootstrap/dist/js/bootstrap.js";

$(function () {
  utils();

  if (typeof lightbox.option == "function") {
    lightbox.option({
      showImageNumberLabel: false,
    });
  }

  $(".copy-link-to-clipboard").on("click", function (event) {
    event.preventDefault();

    $("#copy-to-clipboard-dialog")
      .find(".message")
      .hide()
      .end()
      .modal("show")
      .find("button")
      .on("click", function (event) {
        event.preventDefault();

        const modal = $(this).closest(".modal");
        const ta = modal.find("textarea");

        ta.trigger("focus").trigger("select");

        try {
          let success = document.execCommand("copy");
          if (success) {
            modal.find(".message").slideDown();
            document.getSelection()?.removeAllRanges();
          }
        } catch (err) {
          console.error(err);
        }
      });
  });

  $(".sitewrapper")
    .on("click", "ul.dropdown-menu[data-toggle='dropdown']", function (event) {
      event.preventDefault();
      event.stopPropagation();

      $(this).siblings().toggleClass("show");

      if (!$(this).next().hasClass("show")) {
        $(this)
          .parents(".dropdown-menu")
          .first()
          .find(".show")
          .removeClass("show");
      }
      $(this)
        .parents("li.nav-item.dropdown.show")
        .on("hidden.bs.dropdown", function (e) {
          $(".dropdown-submenu .show").removeClass("show");
        });
    })
    .on("click", "button.dropdown-main-menu-close", function (event) {
      event.preventDefault();
      event.stopPropagation();

      var $navItem = $(this).parent().prev();

      $navItem.siblings().toggleClass("show");
    })
    .on("click", "i.delete", function () {
      $(this).parents(".item").fadeOut();
    });

  // ------------------------------------------------------- //
  // Open & Close Search Panel
  // ------------------------------------------------------ //

  $(".sitewrapper")
    .on("click", ".search", function () {
      $(".search-area").fadeIn();
    })
    .on("click", ".search-area .close-btn", function () {
      $(".search-area").fadeOut();
    });

  // ------------------------------------------------------- //
  // Autoplay videos only on desktops
  // ------------------------------------------------------ //

  var screenWidth = $(window).width();

  // if window width is smaller than 800 remove the autoplay attribute
  // from the video
  if (screenWidth > 800) {
    $("video.bg-video").attr("autoplay", true);
    $("video.bg-video").each(function () {
      this.play();
    });
  }

  // ------------------------------------------------------- //
  // Countdown on coming soon page
  // ------------------------------------------------------ //

  if ($("#countdown").length > 0) {
    $("#countdown").countdown("2020/10/10", function (event) {
      $(this).html(
        event.strftime(
          '<div class="col-6 col-sm-3"><div class="display-3 text-shadow">%D</div>days</div>' +
            '<div class="col-6 col-sm-3"><div class="display-3 text-shadow">%H</div>hours</div>' +
            '<div class="col-6 col-sm-3"><div class="display-3 text-shadow">%M</div>minutes</div>' +
            '<div class="col-6 col-sm-3"><div class="display-3 text-shadow">%S</div>seconds</div>',
        ),
      );
    });
  }

  // ------------------------------------------------------- //
  // Items Carousel
  // ------------------------------------------------------ //

  $(".items-slider").owlCarousel({
    loop: true,
    items: 1,
    thumbs: true,
    thumbsPrerendered: true,
    dots: false,
    responsiveClass: false,
  });

  // ------------------------------------------------------- //
  // Increase/Reduce product amount
  // ------------------------------------------------------ //

  $(".sitewrapper")
    .on("click", ".dec-btn", function () {
      const siblings = $(this).siblings("input.quantity-no");
      if (parseInt(siblings.val(), 10) > 1) {
        siblings.val(parseInt(siblings.val(), 10) - 1);

        if ($(this).closest(".basket").length) {
          updateCartRefreshingPage($(this).closest("form"));
        }
      }
    })
    .on("click", ".inc-btn", function () {
      const siblings = $(this).siblings("input.quantity-no");
      siblings.val(parseInt(siblings.val(), 10) + 1);

      if ($(this).closest(".basket").length) {
        updateCartRefreshingPage($(this).closest("form"));
      }
    })
    .on("change", "input.quantity-no", function () {
      if ($(this).closest(".basket").length) {
        updateCartRefreshingPage($(this).closest("form"));
      }
    });

  function updateCartRefreshingPage(form) {
    form
      .closest(".sitewrapper")
      .load(
        form.attr("action") + " .sitewrapper > *",
        form.serializeArray(),
        function (responseText) {
          console.log("RESPONSE ->", responseText);
        },
      );
  }

  $(".sitewrapper").on(
    "change",
    '.order-details textarea[name="instructions"]',
    function (event) {
      $.ajax({
        method: "post",
        data: {
          instructions: $(this).val(),
        },
      });
    },
  );

  // ------------------------------------------------------- //
  // Scroll to top button
  // ------------------------------------------------------ //

  $(window).on("scroll", function () {
    if ($(window).scrollTop() >= 1500) {
      $("#scrollTop").fadeIn();
    } else {
      $("#scrollTop").fadeOut();
    }
  });

  $("#scrollTop").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1000,
    );
  });

  // ------------------------------------------------------- //
  // Bootstrap select
  // ------------------------------------------------------ //

  $(".bs-select").selectpicker({
    size: 4,
  });

  // ------------------------------------------------------- //
  // Products Slider
  // ------------------------------------------------------ //

  $(".products-slider").owlCarousel({
    loop: false,
    margin: 20,
    dots: true,
    nav: false,
    smartSpeed: 400,
    responsiveClass: true,
    navText: [
      '<i class="fa fa-long-arrow-left"></i>',
      '<i class="fa fa-long-arrow-right"></i>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 4,
      },
    },
  });

  // ------------------------------------------------------- //
  // Brands Slider
  // ------------------------------------------------------ //

  $(".brands-slider").owlCarousel({
    loop: true,
    margin: 20,
    dots: true,
    nav: false,
    smartSpeed: 400,
    responsiveClass: true,
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 6,
        loop: false,
      },
    },
  });

  // ------------------------------------------------------- //
  //  Styled Leaflet Map
  // ------------------------------------------------------ //

  var mapId = "map",
    mapCenter = [53.14, 8.22],
    mapMarker = true;

  if ($("#" + mapId).length > 0) {
    var icon = L.icon({
      iconUrl: "img/marker.png",
      iconSize: [25, 37.5],
      popupAnchor: [0, -18],
      tooltipAnchor: [0, 19],
    });

    var dragging = false,
      tap = false;

    if ($(window).width() > 700) {
      dragging = true;
      tap = true;
    }

    var map = L.map(mapId, {
      center: mapCenter,
      zoom: 13,
      dragging: dragging,
      tap: tap,
      scrollWheelZoom: false,
    });

    var Stamen_TonerLite = L.tileLayer(
      "https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}{r}.{ext}",
      {
        attribution:
          'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        subdomains: "abcd",
        minZoom: 0,
        maxZoom: 20,
        ext: "png",
      },
    );

    Stamen_TonerLite.addTo(map);

    map.once("focus", function () {
      map.scrollWheelZoom.enable();
    });

    if (mapMarker) {
      var marker = L.marker(mapCenter, {
        icon: icon,
      }).addTo(map);

      marker.bindPopup(
        "<div class='p-4'><h5>Info Window Content</h5><p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.</p></div>",
        {
          minwidth: 200,
          maxWidth: 600,
          className: "map-custom-popup",
        },
      );
    }
  }

  // ------------------------------------------------------- //
  //  Cart Link on mobile
  // ------------------------------------------------------ //

  $("body").on("click", "#mini-cart > a", function () {
    if ($(document).width() <= 991) {
      window.location.href = $(this).attr("href");
    }
  });

  // ------------------------------------------------------- //
  //  Remove item from cart page with ajax
  // ------------------------------------------------------ //

  $("body").on("click", ".remove_cart_page", function (e) {
    e.preventDefault();

    const $this = $(this);
    const data = $this.attr("data-id");
    const shopUrl = window.location.origin;

    $.ajax({
      url: `${shopUrl}/shop/includes/_cart_remove.php?id=${data}`,
      success: function () {
        location.reload();
      },
    });
  });

  // ------------------------------------------------------- //
  //  Wishlist
  // ------------------------------------------------------ //

  $("body").on("click", ".remove-wishlist", function () {
    const el = $(this);
    const form = el.closest("form");
    const data = form.serializeArray();
    const action = form.attr("action");

    $.post(action, data, function () {
      el.closest(".item").slideUp();
      $("#mini-wishlist").load(`${location.href} #mini-wishlist > *`);
    });
  });

  $("body").on("click", ".wishlist-to-cart", function () {
    const el = $(this);
    const form = el.closest("form");
    const data = form.serializeArray();
    const action = form.attr("action");

    $.post(action, data, function () {
      el.closest(".item").slideUp();
      initCartGlobally();
    });

    return false;
  });

  // ------------------------------------------------------ //
  // Checkout
  // ------------------------------------------------------ //

  $(".checkout").each(function () {
    const $this = $(this);

    function updateBillingStatus() {
      const checkbox = $this.find('input[type="radio"][name="billing"]');
      let value = false;

      if (checkbox.length) {
        // Auswahl/angemeldeter Kunde
        value = $this.find('input[name="billing"]:checked').val();
      } else {
        // Formular/Gast
        value = $this.find("form:valid").length === 1;
      }
      $this.find('button[type="submit"]').prop("disabled", !value);
    }

    $this
      .find(".billing-form")
      .each(updateBillingStatus)
      .on("change", updateBillingStatus);

    function updateShippingStatus() {
      const shipping = $this.find('input[name="shipping"]:checked').val();
      let can_submit = false;

      if (shipping === "lieferadresse") {
        $this.find(".shipping-address").slideDown();
        $this.find("[data-required]").attr("required", true);
        can_submit = $this.find("form:valid").length === 1;
      } else {
        $this.find(".shipping-address").slideUp();
        $this.find("[data-required]").attr("required", false);
        can_submit = shipping != null;
      }

      $this
        .find('button[type="submit"]:not(.modal button)')
        .prop("disabled", !can_submit);
    }

    $this
      .find("form.shipping-form")
      .find(".shipping-address")
      .hide()
      .end()
      .each(updateShippingStatus)
      .each(function () {
        $this
          .find('button[type="submit"]:not(.modal button)')
          .on("click", function () {
            const value = $this.find('input[name="shipping"]:checked').val();
            if (value === "selbstabholung") {
              $("#selbstabholer-frage").modal("show");
              return false;
            }
          });
      })
      .on("change", updateShippingStatus);

    function updatePaymentStatus() {
      const value = $this.find('input[name="payment"]:checked').val();
      $this.find('button[type="submit"].next').prop("disabled", !value);
    }

    $this
      .find('input[name="payment"]')
      .each(updatePaymentStatus)
      .on("change", updatePaymentStatus);
  });

  // ------------------------------------------------------- //
  //  Mobile Menu Slide Over
  // ------------------------------------------------------ //

  $("#megamenu-toggle, #megamenu-close").on("click", function () {
    $("body").toggleClass("megamenu-open");
  });

  // ------------------------------------------------------ //
  // For demo purposes, can be deleted
  // ------------------------------------------------------ //

  var stylesheet = $("link#theme-stylesheet");
  $("<link id='new-stylesheet' rel='stylesheet'>").insertAfter(stylesheet);
  var alternateColour = $("link#new-stylesheet");

  if ($.cookie("theme_csspath")) {
    alternateColour.attr("href", $.cookie("theme_csspath"));
  }

  $("#colour").change(function () {
    if ($(this).val() !== "") {
      var theme_csspath = "css/style." + $(this).val() + ".css";

      alternateColour.attr("href", theme_csspath);

      $.cookie("theme_csspath", theme_csspath, {
        expires: 365,
        path: document.URL.substr(0, document.URL.lastIndexOf("/")),
      });
    }

    return false;
  });

  function utils() {
    /* click on the box activates the link in it */
    $(".box.clickable").on("click", function (e) {
      window.location = $(this).find("a").attr("href");
    });

    /* external links in new window*/
    $(".external").on("click", function (e) {
      e.preventDefault();
      window.open($(this).attr("href"));
    });

    /* animated scrolling */
    $(".scroll-to, .scroll-to-top").click(function (event) {
      var full_url = this.href;
      var parts = full_url.split("#");
      if (parts.length > 1) {
        scrollTo(full_url);
        event.preventDefault();
      }
    });

    function scrollTo(full_url) {
      var parts = full_url.split("#");
      var trgt = parts[1];
      var target_offset = $("#" + trgt).offset();
      var target_top = target_offset.top - 100;
      if (target_top < 0) {
        target_top = 0;
      }

      $("html, body").animate(
        {
          scrollTop: target_top,
        },
        1000,
      );
    }
  }

  $(".auto-toast").toast("show");
});
